import script from "./WavePlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./WavePlayer.vue?vue&type=script&setup=true&lang=js"

import "./WavePlayer.vue?vue&type=style&index=0&id=0f270c0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f270c0a"]])

export default __exports__